import {Component, OnInit, ViewChild} from '@angular/core';
import {Dealer} from '../models/dealers/dealer.model';
import {HttpService} from '../services/http.service';
import {AuthService} from '../auth/auth.service';
import {EstimationDetailsComponent} from './estimation-details/estimation-details.component';

@Component({
  selector: 'app-estimation',
  templateUrl: './estimation.component.html',
  styleUrls: ['./estimation.component.scss']
})
export class EstimationComponent implements OnInit {

  title = 'warranty-contract-estimations';
  sellingDealers: Array<Dealer>;
  selectedSellingDealerNumber: string;
  displayStartUpButtons = true;
  displayMileage: boolean;
  displaySellingDealer = true;
  displayCarButtons = false;
  displayMotorradButtons: boolean;
  displayEstimationDetails = false;
  selectedContractTypes: Array<string> = ['BMW Premium Selection', 'MINI NEXT'];
  selectedContractType = 'premium';
  displayOrderAndDeliveryDates: boolean;
  @ViewChild(EstimationDetailsComponent)
  estimationDetailsComponent: EstimationDetailsComponent;
  isSelectedContractTypeEuroplus: boolean;

  constructor(private httpService: HttpService, private authService: AuthService) {
  }


  buttonClass(contractType: string): string {
    return contractType === this.selectedContractType ? 'button-estimation_selected' : 'button-estimation';
  }

  onContractTypeChange(contractType: string): void {
    if (this.estimationDetailsComponent) {
      this.estimationDetailsComponent.clearFields();
    }
    this.title = 'warranty-contract-estimations-for-cars';
    this.displayStartUpButtons = false;
    this.displayMotorradButtons = false;
    this.displaySellingDealer = false;
    this.displayMileage = true;
    this.displayCarButtons = true;
    this.displayEstimationDetails = true;
    this.displayOrderAndDeliveryDates = true;
    this.selectedContractType = contractType;
    this.isSelectedContractTypeEuroplus = false;

    switch (contractType) {
      case 'support':
        this.selectedContractTypes = ['MINI Support', 'BMW Support'];
        break;
      case 'euro-plus':
        this.isSelectedContractTypeEuroplus = true;
        this.displayOrderAndDeliveryDates = false;
        this.displayMileage = false;
        this.selectedContractTypes = ['BMW EUROPlus', 'BMWi EUROPlus', 'MINI EUROPlus'];
        break;
      case 'premium':
        this.selectedContractTypes = ['BMW Premium Selection', 'MINI NEXT'];
        break;

      case 'motorrad':
        this.title = 'warranty-contract-estimations-for-bikes';
        this.selectedContractTypes = ['Motorrad Premium Selection'];
        this.displayMotorradButtons = true;
        this.displayCarButtons = false;
        break;
    }
  }

  ngOnInit(): void {
    if (this.authService.isAdmin()) {
      this.httpService.fetchDealers().subscribe((dealers) => {
        this.sellingDealers = dealers;
      });
    } else {
      this.httpService.fetchDealerOptions().subscribe((dealers: Array<Dealer>) => {
        this.sellingDealers = dealers;
      });
    }

  }

}
